// @flow

import * as React from 'react';
import { Link } from '@ta/common.routing';
import { InteractionLogger } from '@ta/tracking.interactions';
import { ResponsiveImage } from '@ta/media.image';
import { Icon } from '@ta/styleguide.icon';
import { localize } from '@ta/common.i18n';

import styles from './ShelfFlightsTopDestSection.less';

type Props = {|
  /** The json flights top destination shelf info object */
  topDestShelfInfo: any,
|};

class ShelfFlightsTopDestSection extends React.PureComponent<Props> {
  render() {
    const { topDestShelfInfo } = this.props;
    const hasPhotos = topDestShelfInfo.thumbnail;
    const topDestShelfInfoUrl =
      topDestShelfInfo && topDestShelfInfo.route && topDestShelfInfo.route.url
        ? topDestShelfInfo.route.url
        : '#';

    return (
      <InteractionLogger>
        {logInteraction => (
          <div className={styles.section}>
            <React.Fragment>
              <Link
                href={topDestShelfInfoUrl}
                className="ui_poi_thumbnail"
                onClick={e => logInteraction(e, 'feedClick')}
              >
                {hasPhotos ? (
                  <div className={styles.photo_wrap}>
                    <div className={styles.shelfForPhoto}>
                      <ResponsiveImage
                        sources={topDestShelfInfo.thumbnail.photoSizes}
                        width="100%"
                        height="100%"
                        borderRadius="2px"
                      />
                    </div>
                  </div>
                ) : (
                  <span className={styles.shelfForPhoto}>
                    {' '}
                    <div className={styles.no_photo_available}>
                      <Icon name="flights" className={styles.icon} />
                    </div>
                  </span>
                )}
              </Link>
              <Link
                href={topDestShelfInfoUrl}
                className="item poi_name ui_link"
                onClick={e => logInteraction(e, 'feedClick')}
              >
                <span className={styles.name}>{topDestShelfInfo.locationName}</span>
                {this.props.topDestShelfInfo.displayPrice && (
                  <span className={`${styles.name} ${styles.price}`}>
                    {localize(
                      'from_price_fffff32b',
                      {
                        '0': this.props.topDestShelfInfo.displayPrice,
                      } /* From {0} */,
                    )}
                  </span>
                )}
              </Link>
              {<Link href={topDestShelfInfoUrl} onClick={e => logInteraction(e, 'feedClick')} />}
            </React.Fragment>
          </div>
        )}
      </InteractionLogger>
    );
  }
}

export default ShelfFlightsTopDestSection;
